// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__km6WP","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__rIuMt"};